import React from 'react';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyPrioritySchemes = lazyForPaint(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-admin-pages-priority-schemes", jiraSpaEntry: "async-admin-pages-priority-schemes" */ '@atlassian/jira-admin-pages-priority-schemes/src/ui/index.tsx'
		),
	),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyPrioritySchemes}
		pageId="jira-admin-pages-priority-schemes"
		shouldShowSpinner
	/>
);
